export const formatDate = (date: string | Date) =>{
  return new Date(date).toLocaleDateString("nl-NL", dateOptions)
}

const dateOptions = {
  year: "numeric",
  month: "long",
  day: "numeric",
  timeZone: "Europe/Amsterdam",
} as const

export const formatYear = (date: string | Date) => {
  return new Date(date).toLocaleDateString("nl-NL", yearOptions)
}

const yearOptions = {
  year: "numeric",
  timeZone: "Europe/Amsterdam",
} as const
